import styled from "styled-components";
import {
  Heading,
  Paragraph,
  Icon as IconElement,
  Card as CardElement,
} from "react-ui-kit";
import RContainer from "../../components/ResponsiveContainer";
import { Spinner } from "../../components/SpinnerLoading";

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const H2 = styled(Heading).attrs({
  type: "h2",
})``;

export const P = styled(Paragraph)``;

export const ResponsiveContainer = styled(RContainer)`
  padding: 30px 36px;
`;

export const Header = styled.div`
  margin-bottom: 40px;
  h2 {
    margin-bottom: 10px;
  }
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  a,
  a:hover,
  a:active,
  a:visited,
  a:focus {
    text-decoration: none;
  }
  @media (min-width: 375px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  i {
    color: #777777;
  }
`;

export const Card = styled(CardElement).attrs(({ theme }) => ({
  backgroundColor: theme.colors.primary,
}))`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 162px;
  height: 142px;
  margin-bottom: 20px;
  p {
    color: ${({ theme }) => theme.colors.textInPrimaryColor};
  }

  i {
    color: ${({ theme }) => theme.colors.textInPrimaryColor} !important;
    font-size: 36px;
    margin-bottom: 15px;
  }

  @media (min-width: 375px) {
    width: 140px;
    height: 122px;
  }

  @media (min-width: 425px) {
    width: 162px;
    height: 142px;
  }

  @media (min-width: 576px) {
    width: 152px;
    height: 133px;
  }

  @media (min-width: 768px) {
    width: 162px;
    height: 142px;
  }
`;

export const Icon = styled(IconElement)``;

export const Loading = styled(Spinner)``;
